
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.964 6.872C22.643 3.338 20.14.773 17.01.773c-2.086 0-3.996 1.123-5.07 2.922C10.873 1.872 9.042.773 6.99.773c-3.13 0-5.632 2.564-5.953 6.099-.026.156-.13.977.187 2.317.456 1.933 1.51 3.691 3.046 5.083l7.664 6.955 7.796-6.954c1.537-1.393 2.59-3.15 3.046-5.084.317-1.34.213-2.16.188-2.317zm-1.012 2.124c-.416 1.765-1.381 3.373-2.788 4.647L11.94 20.09l-7.1-6.444c-1.41-1.277-2.375-2.885-2.791-4.65-.3-1.268-.177-1.984-.176-1.989l.006-.043C2.153 3.867 4.303 1.62 6.99 1.62c1.983 0 3.73 1.218 4.558 3.18l.39.923.389-.924c.815-1.93 2.653-3.179 4.683-3.179 2.687 0 4.838 2.248 5.118 5.385 0 .007.124.724-.176 1.992z","fill-rule":"evenodd","stroke-width":".5"}})])
          )
        }
      }
    